/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Quick_Action_SublineInputs */

const de_orders_quick_action_subline = /** @type {(inputs: Orders_Quick_Action_SublineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellungen und Rücksendungen einsehen`)
};

/** @type {(inputs: Orders_Quick_Action_SublineInputs) => LocalizedString} */
const en_orders_quick_action_subline = de_orders_quick_action_subline;

/**

* @param {Orders_Quick_Action_SublineInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const orders_quick_action_subline = /** @type {((inputs?: Orders_Quick_Action_SublineInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Quick_Action_SublineInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_orders_quick_action_subline(inputs)
	return en_orders_quick_action_subline(inputs)
});